import { combineReducers } from 'redux';
import fuelReport from './fuelReport';
import user from './user';
import marketing from './marketing';
import ubi from './ubi';
import membership from './membership';
import home from './home';

export default combineReducers({
  fuelReport,
  user,
  marketing,
  ubi,
  membership,
  home,
});
